/**
 * Masque la barre de filtres fixe (.facets-wrapper) dès que l'utilisateur a
 * terminé de scroller la grille produits, puis la ré-affiche s'il remonte.
 *
 * Compatible avec l'infinite scroll (assets/infinite-scroll.js) : tant qu'il
 * reste des pages à charger (hasMorePages) ou qu'un chargement est en cours
 * (isLoading), la grille n'est PAS considérée comme terminée -> la barre reste.
 *
 * Le bouton se masque quand le footer entre dans le viewport (« au niveau du
 * footer »). Détection par mesure directe à chaque scroll (pas de sentinelle ni
 * d'IntersectionObserver, peu fiables dans le contexte grid/flex de la grille).
 */
(function () {
  "use strict";

  var HIDDEN_CLASS = "facets-wrapper--hidden";

  function moreComing() {
    // L'infinite scroll n'est actif que sur les pages /collections/.
    if (window.location.pathname.indexOf("/collections/") === -1) return false;
    var infinite = document.querySelector("infinite-scroll");
    if (!infinite) return false;
    return infinite.hasMorePages === true || infinite.isLoading === true;
  }

  function setup(bar, grid) {
    var container =
      grid.closest(".product-grid-container") || grid.parentElement || grid;
    var scheduled = false;

    function evaluate() {
      scheduled = false;
      var drawerOpen = !!document.querySelector(
        ".mobile-facets__disclosure.menu-opening"
      );
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // Collection trop courte pour scroller : on garde le bouton.
      var scrollable = document.documentElement.scrollHeight > vh + 4;

      var footer =
        document.querySelector(".footer") || document.querySelector("footer");
      var hide;
      if (footer) {
        // Footer visible => on est bien tout en bas (les produits et l'infinite
        // scroll sont au-dessus du footer), donc pas besoin de tester l'état de
        // l'infinite scroll ici.
        hide = footer.getBoundingClientRect().top <= vh && scrollable && !drawerOpen;
      } else {
        // Repli sans footer : bas de la grille + garde infinite scroll.
        var reached = container.getBoundingClientRect().bottom <= vh + 1;
        hide = reached && scrollable && !drawerOpen && !moreComing();
      }
      bar.classList.toggle(HIDDEN_CLASS, hide);
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(evaluate);
      else evaluate();
    }

    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule, { passive: true });
    window.addEventListener("load", evaluate);

    // Recalcule quand la grille change (infinite scroll, changement de filtres).
    try {
      new MutationObserver(evaluate).observe(grid, {
        childList: true,
        subtree: true,
      });
    } catch (e) {}

    evaluate();
  }

  function tryInit() {
    var bar = document.querySelector(".facets-wrapper");
    var grid = document.getElementById("product-grid");
    if (!bar || !grid) return false;
    if (bar.dataset.autoHideBound === "1") return true;
    bar.dataset.autoHideBound = "1";
    setup(bar, grid);
    return true;
  }

  function boot() {
    if (tryInit()) return;
    // Grille/barre pas encore présentes (rendu tardif type Depict) : on attend.
    var mo = new MutationObserver(function () {
      if (tryInit()) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      mo.disconnect();
    }, 15000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
